import useMutationCall from "../../../hooks/useMutationCall";
import { usePatchEmployeeMutation } from "../employeesSlice";

const useEmployeePatch = () => {
  return useMutationCall(usePatchEmployeeMutation);
};

export default useEmployeePatch;
